import React from 'react'
import "./Users.css";
//import { useNavigate } from 'react-router-dom'
import { usePreload } from '../hooks/usePreload';
import { useUser } from '../hooks/useUser';
import { userApi } from '../api/user';
import { useAppDispatch } from '../redux/hooks';
import { fetchPreload } from '../redux/slices/preloadSlice';
import PageHeader from './PageHeader';

const Users: React.FC = () => {
  const queryParams = new URLSearchParams(location.search);
  const lla = queryParams.get("lla"); // LiveLet admin page = 1
  const userEditToken = queryParams.get("uet");

  const preload = usePreload();
  const users = preload?.users;
  const cards = preload?.cards;
  const user = useUser();
  const dispatch = useAppDispatch();
  // 社員一覧との同期（新しい社員の追加・氏名の更新・退職者の削除）は名刺 API が preload のたびに行う（cardapi の syncUsersTable）。
  // 以前ここにも同じ同期があったが、社員一覧の API を名刺サイト自身のドメインに取りに行っていて一度も動いていなかったため外した（2026-11-02）
//  const navigate = useNavigate();

  async function handleSave(targetUser: any, role: string, status: boolean) {
    if (!user.userKey || !user.userToken || status == null || status == undefined) return;
    // console.log(selectedUser);
    const statusNumber = status ? 1 : 0;
    try {
      await userApi.editUser(targetUser.userKey, role, statusNumber, userEditToken || "");
      dispatch(fetchPreload());
    } catch (error) {
      console.error("Failed to edit user or fetch updated data:", error);
    }
  };

  const usersList = users
    ?.filter(usr => usr.externalUserKey)
    .sort((a, b) => {
      if (a.externalUserKey && b.externalUserKey) {
        return a.externalUserKey > b.externalUserKey ? 1 : -1;
      }
      return 0;
    })
    .map((user) => {

    const userCard = cards?.find(card => card.ownerKey == user.userKey);
    const hasCard = Boolean(userCard);

    const roles = [
      { label: "admin", isChecked: user.isAdmin },
      /*{ label: "editor", isChecked: user.isEditor },*/
      /*{ label: "creator", isChecked: user.isCreator },*/
    ];

    const roleChecks = roles.map((role, index) => (
      <span key={index} className="userList__cell userList__cell--center userList__role">
        <input type="checkbox" aria-label={`${user.employeeId ?? ""} の管理者権限`} onChange={() => { handleSave(user, role.label, !role.isChecked) }} checked={!!role.isChecked} className="role-check" />
      </span>
    ));

    const systemName = (Boolean(user.lastName) || Boolean(user.firstName)) ? `${user.lastName || ""}, ${user.firstName || ""}` : null;
    const cardName = userCard ? `${userCard.content?.lastName?.[0]?.content ?? ""} ${userCard.content?.firstName?.[0]?.content ?? ""}` : null;
    const displayedName = (systemName && cardName) ? `${systemName} (${cardName})` : Boolean(systemName) ? systemName : Boolean(cardName) ? cardName : "No name";

    return (
      <div key={user.userKey} className="userList__row">
        <span className="userList__cell userList__id">{user.employeeId}</span>
        <span className="userList__cell userList__cell--center userList__hasCard">
          {/* 名刺あり: 記号「✔」ではなく SVG で描く */}
          {hasCard
            ? <svg width="16" height="12" viewBox="0 0 16 12" role="img" aria-label="あり"><path d="M1 6l5 5L15 1" fill="none" stroke="currentColor" strokeWidth="2" /></svg>
            : <span className="sr-only">なし</span>}
        </span>
        <span className="userList__cell userList__name">{displayedName}</span>
        {roleChecks}
      </div>
    );

  });

  return (
    <div className="top-page-container">
      <PageHeader title="ユーザー" showBack={lla != "1"} />
      <div className="pageBody">
      {/* <span style={{ display: "flex" }}>Number of users: {users?.length}</span> */}
      {/* 名刺の検索の表と同じ形（見出し行 #E4E4E4・行の下線・最後の行は線なし）。スマホは枠の中で横スクロール */}
      <div className="userList drop-shadow-md">
        <div className="userList__table">
          <div className="userList__row userList__head">
            <span className="userList__cell userList__id">従業員ID</span>
            <span className="userList__cell userList__cell--center userList__hasCard">名刺あり</span>
            <span className="userList__cell userList__name">氏名</span>
            <span className="userList__cell userList__cell--center userList__role">管理者権限</span>
          </div>
          {usersList}
        </div>
      </div>
      </div>
    </div>
  )
}

export default Users
